import React, { useState } from 'react'
import Box from '@material-ui/core/Box'

import Http from '../../shared/http'
import { Modal, ModalHeader, ModalSubHeader, ModalContent } from '@components/Modal'
import { Button } from '@components/Button'

type ArchiveScenarioModalProps = {
  open: boolean, 
  close: () => void, 
  scenario?: {
    id: string,
    name: string,
    plan_type?: string,
  },
  updateScenario: () => Promise<{
    success: boolean,
    message?: string
  }>
 }

const ArchiveScenarioModal = ({
  open,
  close,
  scenario,
  updateScenario
}) => {
  const [archiving, setArchiving] = useState<boolean>(false)
  const [message, setMessage] = useState<string | undefined>(undefined)

  const onArchive = async () => {
    setArchiving(true);
    const result = await updateScenario();

    setArchiving(false);

    if (!result.success) {
      setMessage(result.message || "There was an error, please try again.");
    } else {
      // Success :)
      close();
    }
  }
  return (
    <Modal open={open} onClose={close}>
      <ModalHeader>Archive your scenario</ModalHeader>
      <ModalSubHeader>It's kinda like stuffing papers into a drawer.</ModalSubHeader>
      <ModalContent>
        <p className='text-center'>{message || "Are you sure you would like to archive this scenario?"}</p>
        <p className='text-center'>{scenario?.name}</p>
        <Box
          display='flex'
          justifyContent='center'
          className='flex justify-center gap-4'
        >
          <Button secondary disabled={archiving} onClick={close}>{archiving ? 'Archiving' : 'Go back'}</Button>
          <Button warning disabled={archiving} onClick={onArchive}>{archiving ? 'Archiving' : 'Archive'}</Button>
        </Box>
        <Box
          mt='1rem'
          display='flex'
          justifyContent='center'
          alignItems='center'
          flexDirection='column'
        >
          <small>Once you archive your scenario, you won't be able to access it again.</small>
          <small>We're working on a way to give you access to view archived scenarios.</small>
        </Box>
      </ModalContent>
    </Modal>
  )
}

export { ArchiveScenarioModal }
